import Script from 'next/script';
import { useRef } from 'react';

import { TextLinkButton } from '#components/base/TextButton';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import { COMMENT_BUTTON_ID, useComments } from '#cutils/hooks/useComments';

import styles from './ArticleSectionComments.module.scss';
import type { ArticleSectionCommentsFragment } from './__generated__/ArticleSectionComments.generated';

type Props = {
	article: ArticleSectionCommentsFragment & { addCoralInvalidation?: boolean };
	className?: string;
};

export function ArticleSectionComments({ article, className = '' }: Props) {
	const articleRowId = article.rowId || '';
	const { flags } = useEnvironment();

	const ref = useRef<HTMLDivElement>(null);
	const {
		endpoints: { ENDPOINT_CORAL },
	} = useEnvironment();
	const {
		setIsCommentsScriptLoaded,
		isVisible: isCommentsVisible,
		linkProps,
	} = useComments({
		articleRowId,
		ref,
	});

	return !flags.IS_COMMENTS_HIDDEN && article.allowComments ? (
		<>
			{isCommentsVisible && <Script src={`${ENDPOINT_CORAL}/assets/js/embed.js`} onReady={() => setIsCommentsScriptLoaded(true)} />}
			{article.addCoralInvalidation ? <script src="api/invalidate-coral-token.js" async={true} /> : null}

			<section className={`${styles.commentsSection} ${className}`}>
				<TextLinkButton
					id={COMMENT_BUTTON_ID}
					className={styles.button}
					display="default"
					iconName={isCommentsVisible ? 'chevron-up' : 'chevron-down'}
					iconVariant="filled"
					{...linkProps}
				>
					Kommentare
				</TextLinkButton>

				<div ref={ref} id={`coral-embed-stream-${articleRowId}`} className={styles.wrapper} />
			</section>
		</>
	) : null;
}
